import React from "react";
import { HOW_STEPS } from "@/lib/brand";

export default function HowItWorks() {
  return (
    <section data-testid="how-section" id="how-it-works" className="py-16 md:py-24 bg-mint">
      <div className="container-x">
        <div className="max-w-2xl">
          <h2 className="text-[32px] md:text-[44px] font-extrabold text-navy">How it works</h2>
          <p className="mt-3 text-ink/85">From the first call to a nurse arriving at your door — usually the same day.</p>
        </div>

        <ol className="mt-10 grid grid-cols-1 md:grid-cols-4 gap-6 relative">
          <div className="hidden md:block absolute top-7 left-10 right-10 h-0.5 bg-care/30" />
          {HOW_STEPS.map((s, i) => (
            <li key={s.n} data-testid={`step-${i}`} className="relative">
              <div className="w-14 h-14 rounded-full bg-care text-white flex items-center justify-center text-[22px] font-extrabold shadow-soft relative z-10">
                {s.n}
              </div>
              <h3 className="mt-4 text-[18px] font-bold text-navy">{s.title}</h3>
              <p className="mt-1 text-[15px] text-ink/80">{s.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
